import { render, staticRenderFns } from "./DateTimeFormatter.vue?vue&type=template&id=dfb6b5b6&scoped=true"
import script from "./DateTimeFormatter.vue?vue&type=script&lang=js"
export * from "./DateTimeFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb6b5b6",
  null
  
)

export default component.exports